import { Component, Input } from '@angular/core';
import { NewsId } from './select-product-form-modal.types';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from '../shareModule/services/customer.service';

@Component({
  selector: 'app-select-product-to-attach',
  templateUrl: './select-product-to-attach.component.html',
  styleUrl: './select-product-to-attach.component.scss'
})
export class SelectProductToAttachComponent {
  @Input()
  public type : 'news';

  @Input()
  public  set newsId(value : NewsId){
    this._newsId = value;
    this.refreshView()
  }

  public allProducts = [];
  public linkedProduct: Set<any> = new Set()

  constructor(private auth: AuthServiceService, private toastr: ToastrService, private customerService: CustomerService){}
  
  public searchKeyword = ''
  public refreshView(){
    this.customerService.getMemberShopProductList(
       {
        search: this.searchKeyword,
        limit: 3,
       }
    ).subscribe(
      {
        error: err =>{
          console.error(err);
          this.toastr.error("Something went wrong while fetching products")
        },
        next: (data: any) =>{
          this.allProducts = data.body.data;
        }
      }
    )

    this.auth.getPagesLinkToProduct(this.type, this._newsId)
    .subscribe(
      {
        next: data =>{
          for(const selected of data.body){
            this.linkedProduct.add(selected.productId)
          }
        },
        error: console.error
      }
    )

  

  }

  public toggleProductLink(product){
    this.auth.toggleLinkProductToPage(this.type, this._newsId, product.id)
    .subscribe({
      next: ()=>{
        if(this.linkedProduct.has(product.id)){
          this.linkedProduct.delete(product.id);
        }else{
          this.linkedProduct.add(product.id)
        }
        this.toastr.success("Changed successfully!")
      },
      error: err=>{
        console.error(err);
        this.toastr.error("Error something wrong when trying to toggle page product link")
      }
    })

  }

  public get proudId() : NewsId{
    return this._newsId;
  }


  private  _newsId? :NewsId;

}
